<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="checkModuleAccess2(constAccessType.add)">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["MD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="close()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content dpt-wtd">
                                    <CRow>
                                        <CCol col="6" >
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TMD"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_tm"
                                                        :placeholder="this.utilGetDDLanguage('MTA.TMD')"
                                                        v-model="obj_ad['TM']"
                                                        :clearable="false"
                                                        openDirection="below"
                                                        @input="TransTypeChange" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="4" v-if="getUserInfo.AT !== 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        v-model="obj_ad['AGIT']"
                                                        @input="AgentGroupChange"
                                                        value-format="object"
                                                        openDirection="below"
                                                        ref="AGIT"/>
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                        <CCol col="4">
                                            <label class="col-form-label-sm">{{this.getLanguage['GL']['SAGT']}}  :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :key = "rtSubBrand"
                                                        :defaultOptions="dd_DefaultSubBrand"
                                                        :load-options="loadSubBrandOptions"
                                                        :noResultsText="this.getLanguage['GL']['NRF']"
                                                        :cacheOptions="false"
                                                        :options="dd_subagentgroup"
                                                        :clearable="false"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                        v-model="obj_ad['SAGAGI']"
                                                        @input="SubAgentGroupChange"
                                                        :disabled="!obj_ad['AGIT']"
                                                        openDirection="below" />
                                            <!--<span class="ErrMsg">{{ ValidationErrMsg('MI','MUN') }}</span>-->
                                        </CCol>
                                        <CCol col="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} <span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :load-options="loadMemberOptions"
                                                        :cacheOptions="false"
                                                        :options="dd_mem"
                                                        :clearable="false"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('MEM.U')"
                                                        v-model="obj_ad['MI']"
                                                        @input="MemberChange"
                                                        openDirection="below"
                                                        ref="MI"/>
                                            <span class="ErrMsg">{{ ValidationErrMsg('MI','MUN') }}</span>
                                        </CCol>
                                    </CRow>


                                    <CRow v-if="getUserInfo.AT < 4">
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["MTA"]["BKN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_bank"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        :placeholder="this.utilGetDDLanguage('MTA.BKN')"
                                                        v-model="obj_ad['BNI']"
                                                        :clearable="false"
                                                        @input="BankNameChange"
                                                        openDirection="below"
                                                        :disabled="obj_ad['TM']!=0"
                                                        ref="BNI"/>
                                            <span class="ErrMsg">{{ ValidationErrMsg('BNI','BKN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm"> {{getLanguage["MTA"]["BAN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_bankacc"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        :placeholder="this.utilGetDDLanguage('MTA.BAN')"
                                                        :clearable="false"
                                                        v-model="obj_ad['BAI']"
                                                        openDirection="below"
                                                        :disabled="obj_ad['TM']!=0"
                                                        @input="BankAccountChange"
                                                        ref="BAI"/>
                                            <span class="ErrMsg">{{ ValidationErrMsg('BAI','BAN') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6" v-if="getUserInfo.AT < 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MB"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_membankname"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        :placeholder="this.utilGetDDLanguage('MTA.MB')"
                                                        :clearable="false"
                                                        v-model="mamBankAcc"
                                                        openDirection="below"
                                                        :disabled="obj_ad['TM']!=0" />

                                        </CCol>

                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{this.getLanguage["MTA"]["TA"]}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span><span v-if="getUserInfo.AT == 4" class="float-right label-tooltip" style="padding-top:2px;">{{ this.getLanguage['AG']['SBAB']}} : {{ this.AvailableBalanceAmount() }}</span></label>
                                            <CInput :prepend="CurrencySymbol_crypto"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_ad.TA, getThousandCurrency ? 3 : 2)"
                                                    @change="v => {obj_ad.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2);BankAccountChange();}"
                                                    ref="TA" />
                                            <span class="text-danger" v-if="convertTransAmount">{{this.convertTransAmount}}</span>
                                            <span class="ErrMsg">{{ ValidationErrMsg('TA','TA') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" v-if="getUserInfo.AT < 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TID"]}} :</label>
                                            <CInput size="sm" :value="obj_ad.TID" @change="v => obj_ad.TID = v" :disabled="obj_ad['TM']!=0" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RURL"]}} :</label>
                                            <div style="display:block;">
                                                <input type="file" name="pic" accept="image/*, .pdf" @change="onFileSelected" style="overflow: hidden;" />
                                            </div>
                                            <!-- <span class="ErrMsg">{{ ValidationErrMsg('RURL','RURL') }}</span> -->
                                        </CCol>

                                    </CRow>
                                    <CRow>
                                        <CCol col="6" v-if="getUserInfo.AT < 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["PMT"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_promo"
                                                        v-model="obj_ad['PMT']"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        :placeholder="this.utilGetDDLanguage('MTA.PMT')"
                                                        openDirection="below"
                                                        @input="PromoCodeChange" />
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["PMTR"]}} :</label>
                                            <div style="display:block;">
                                                <label class="col-form-label-sm">{{ str_promotitle }} </label>
                                            </div>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                            <textarea vertical="" rows="4" class="form-control form-control-sm" :value="obj_ad.R" @change="TextValueChange('R',$event)" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton v-shortkey="['enter']" @shortkey="saveDeposit()" :disabled="sensBtn" color="outline-success" size="sm" @click="saveDeposit()">
                                        {{this.getLanguage['MTA']['MD']}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf, decimal, minValue } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import axios from "axios";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                str_bankacc_used_agi: 0,
                str_member_used_agi: 0,
                selectedFile: null,
                bool_CV: false, // Check Validation
                bool_fullLoading: false, //Loading Visible
                sensBtn: true,
                bool_fullScreen: loadingFullScreen, //Full Screen
                str_promotitle: "",
                obj_ad:
                {
                    AGI: null,
                    MI: null,
                    TM: 0,
                    TID: "",
                    BAI: null,
                    BNI: null,
                    MB: "",
                    MBN: "",
                    MBA: "",
                    PMT: null,
                    R: "",
                    RS: 2,
                    IMA: 1,
                    TT: 1,
                    PM: null,
                    RURL: "",
                    AC: 2,
                    TA: "",
                    CI: 0,
                    CS: "",
                    DI: 0,
                    FDA: null,
                    FCS: null,
                    ER: 1,
                    TCS: null,
                    TER: 1,
                }, // add deposit
                mamBankAcc: null,
                // dropdown value
                dd_agentgroup: [], //agent group option
                dd_subagentgroup: [],
                ddBankBrandList: [],
                dd_bank: [],
                constAccessType: constAccessType,
                dd_bankacc: [],
                dd_membankname: [],
                dd_mem: [],
                dd_promo: [],
                dd_tm: [], // transaction type
                CurrencySymbol: "",
                CurrencySymbol_crypto: "",
                ISOCode: "",
                str_sagcreditbalance: '',
                //bool_cacheOptionValue: true
                dd_DefaultSubBrand: [],
                rtSubBrand: 0,
                convertTransAmount: null,
                hasTransLoading: false
            }
        },
        validations: {
            obj_ad: {
                TM: { required },
                MI: { required },
                AGIT: {
                    required: requiredIf(function (vm) {
                        return vm.TM == 0 || vm.TM == 1;
                    }),
                },
                BNI: {
                    required: requiredIf(function (vm) {
                        return vm.TM == 0;
                    }),
                },
                BAI: {
                    required: requiredIf(function (vm) {
                        return vm.TM == 0;
                    }),
                },
                TA: {
                    decimal,
                    minValueValue: minValue(0),
                    required: requiredIf(function (vm) {
                        return vm.TM == 0 || vm.TM == 1;
                    }),
                }
            }
        },
        created() {
            this.$parent.showSubMenu = 'D';
            this.$parent.showActiveMenu = 'D.MD';

            if (this.getUserInfo.AT == 4) {
                this.obj_ad.TM = 1;
                this.obj_ad['AGIT'] = true;
                this.getSubAgentGroup(0, true);
                this.sensBtn = (this.isSENS == 0) ? false : true;
            }
            else {
                this.obj_ad.TM = 0;
                this.dd_DefaultSubBrand = [];
            }

            this.getAgentGroup();
            this.getTMList();
            this.setThousandCurrency(false);
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_ad.R = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MD', 'D', type);
            },
            close() {
                if (!this.checkModuleAccess('DDU', 'D', this.constAccessType.view)) {
                    this.$router.push("/M/ML");
                }
                else {
                    this.$router.push("/D/DDU");
                }
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event, 0.2, [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".webp"]);
            },
            getTMList() {
                //this.dd_tm = [{id: '0',label: this.getLanguage['MTA']['TM0']},{id: '1',label: this.getLanguage['MTA']['TM1']}];
                if (this.getUserInfo.AT == 4) {
                    this.dd_tm = [{ id: '1', label: this.getLanguage['MTA']['TM1'] }];
                }
                else {
                    this.dd_tm = [{ id: '0', label: this.getLanguage['MTA']['TM0'] }];
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup[0].children == undefined) {
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                if ((at == 3 || at == 4) && that.dd_agentgroup.length < 2) {
                                    that.obj_ad.AGIT = that.dd_agentgroup[0];
                                    that.AgentGroupChange();
                                }
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            TransTypeChange(value) {
                this.obj_ad.TID = "";
                this.obj_ad.BAI = null;
                this.obj_ad.BNI = null;
                this.obj_ad.MB = "";
                this.obj_ad.MBA = "";
                this.obj_ad.MBN = "";
                this.obj_ad.PMT = null;
                this.obj_ad.R = "";
            },
            BankNameChange(value) {
                this.obj_ad['BAI'] = null;
                this.dd_bankacc = [];

                if (value != undefined) {
                    var that = this;
                    this.getDataApi(`/api/dd/bankacc/` + value + "/" + this.str_bankacc_used_agi + "/3/0/" + this.CurrencySymbol,
                        function (d, s) {
                            if (s) {
                                that.dd_bankacc = d.dropdownlist;
                            }
                        });
                    this.CurrencySymbol_crypto = this.CurrencySymbol;
                }

            },
            BankAccountChange() {
                var value = this.obj_ad.BAI;
                this.obj_ad.FCS = null;
                this.obj_ad.FDA = null;
                this.obj_ad.ER = null;
                if (value) {
                    var bankAccount = this.dd_bankacc.find(obj => {
                        return obj.id == value;
                    });
                    if (bankAccount && bankAccount.FCS != '') {
                        this.obj_ad.FCS = bankAccount.FCS;
                        this.obj_ad.ER = bankAccount.ER;
                        this.obj_ad.TCS = bankAccount.TCS;
                        this.obj_ad.TER = bankAccount.TER;
                        this.CurrencySymbol_crypto = bankAccount.FCS

                        if (this.obj_ad.TA > 0) {
                            this.obj_ad.FDA = this.obj_ad.TA;
                            this.convertTransAmount = bankAccount.FCS+ ' ' + this.obj_ad.TA + ' * ' + bankAccount.TER + ' = ' + bankAccount.TCS + ' ' + (Math.floor((bankAccount.TER * this.obj_ad.TA) * 100) / 100).toFixed(2);
                        }

                    } else {
                        this.convertTransAmount = null;
                    }
                } else {
                    this.convertTransAmount = null;
                }
            },
            MemberChange(value) {
                var that = this;
                this.obj_ad['MB'] = null;
                this.dd_membankname = [];
                this.str_sagcreditbalance = '';
                var memberid = value;
                this.obj_ad['CI'] = 0;
                if (memberid) {
                    var selectedAGI = 0;
                    var agiSelectedValue = this.obj_ad['AGIT'].id;
                    var agentList = agiSelectedValue.split("-");
                    //if (this.obj_ad['SAGAGI']) {
                    //    selectedAGI = this.obj_ad['SAGAGI'];

                    if (that.obj_ad['SAGAGI']) {
                        this.getDataApi(`/api/ag/gb-sub-cur/${that.obj_ad['SAGAGI']}/${memberid}`,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.str_sagcreditbalance = that.formatNumber(d.D.CDBL, d.D.DS, d.D.TS, 2, d.D.CS)
                                }
                            });
                    }
                    //}
                    //else {
                    selectedAGI = agentList[agentList.length - 1];
                    //}
                    //this.getDataApi(`/api/memtrans/gcs/` + value,
                    //    function (d, s) {
                    //        if (s) {
                    //            that.CurrencySymbol = d;
                    //            that.CurrencyChange(d);
                    //            that.getBankDD(d);
                    //        }
                    //    });
                    this.getDataApi(`/api/memtrans/gc/` + value,
                        function (d, s) {
                            if (s) {
                                that.ISOCode = d.ISOC;
                                that.CurrencySymbol = d.CS;
                                that.CurrencySymbol_crypto = d.CS;
                                that.obj_ad['CI'] = d.I;
                                that.obj_ad['CS'] = d.CS;
                                that.CurrencyChange(d.CS);
                                that.getBankDD(d.CS);
                            }
                        });
                    this.getDataApi(`/api/dd/dptpromo/` + selectedAGI + `/` + memberid,
                        function (d, s) {
                            if (s) {
                                that.dd_promo = d.dropdownlist;
                            }
                        });

                    this.getDataApi(`/api/dd/memberbankname/` + memberid,
                        function (d, s) {
                            if (s) {
                                that.dd_membankname = d.dropdownlist;
                            }
                        });
                }
            },
            AvailableBalanceAmount() {
                if (this.getUserInfo.AT == 4) {
                    return this.str_sagcreditbalance;
                }
                return '';
            },
            AgentGroupChange() {
                this.obj_ad['MI'] = null;
                this.obj_ad['BAI'] = null;
                this.obj_ad['BNI'] = null;
                this.obj_ad['SAGAGI'] = null;

                this.dd_mem = [];
                this.dd_bank = [];
                this.dd_bankacc = [];
                this.dd_promo = [];

                if (this.obj_ad['AGIT']) {
                    var agiSelectedValue = this.obj_ad['AGIT'].id;
                    var agentList = agiSelectedValue.split("-");
                    this.str_bankacc_used_agi = agentList[agentList.length - 1];
                    this.str_member_used_agi = this.str_bankacc_used_agi;
                }
                this.sensBtn = ((this.isSENS == 1 && this.str_bankacc_used_agi != this.curAGI) ? true : false);
            },
            SubAgentGroupChange() {
                this.obj_ad['MI'] = null;
                this.obj_ad['BAI'] = null;
                this.obj_ad['BNI'] = null;

                this.dd_mem = [];
                this.dd_bank = [];
                this.dd_bankacc = [];
                this.dd_promo = [];

                if (this.obj_ad['AGIT'] && this.obj_ad['SAGAGI']) {
                    this.str_member_used_agi = this.obj_ad['SAGAGI'];
                }

            },
            getSubAgentGroup(value, isFirstLoad = false) {
                var that = this;
                this.getDataApi(`/api/dd/subbrand/0/0/${value}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);

                            if (isFirstLoad) {
                                that.obj_ad['SAGAGI'] = that.dd_DefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                            }
                        }
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    this.dd_mem = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.str_member_used_agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_mem = d.dropdownlist;
                            }
                            else {
                                that.dd_mem = [];
                            }
                            callback(null, that.dd_mem);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                var agiSelectedValue = this.obj_ad['AGIT'].id;
                var agentList = agiSelectedValue.split("-");
                if (agentList.length > 0) {
                    parentAGI = agentList[1];
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            getBankDD(cs) {
                var that = this;
                //// deposit with auto deposit bank return
                this.getDataApi(`/api/dd/bank/` + this.str_bankacc_used_agi + "/3/0/" + cs,
                    function (d, s) {
                        if (s) {
                            that.dd_bank = d.dropdownlist;
                        }
                    });
            },
            PromoCodeChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.getDataApi(`/api/memtrans/gpr/` + value,
                        function (d, s) {
                            if (s) {
                                that.str_promotitle = d;
                            }
                        });
                } else {
                    this.str_promotitle = "";
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_ad[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage["MTA"][langKey]);
                    }
                }

            },
            saveDeposit(ccp) {
                this.bool_CV = true;
                this.bool_fullLoading = true;
                this.obj_ad['MB'] = "";
                this.obj_ad['MBA'] = "";
                this.obj_ad['MBN'] = "";
                for (var i = 0; i < this.dd_membankname.length; i++) {
                    if (this.mamBankAcc == this.dd_membankname[i].id) {
                        var accountData = this.dd_membankname[i].label.split('-');
                        this.obj_ad['MB'] = accountData[0];
                        this.obj_ad['MBA'] = accountData[1];
                        this.obj_ad['MBN'] = accountData[2];
                    }
                }

                //CASH DEPOSIT
                if (this.obj_ad['TM'] == 0) {
                    this.obj_ad['PM'] = 1;
                    this.obj_ad['DSRT'] = "::[MTA][DST]::";   //this.getLanguage["MTA"]["DST"];
                    this.obj_ad['DSRM'] = "::[MTA][DSM]::";   //this.getLanguage["MTA"]["DSM"];
                }

                //CREDIT DEPOSIT
                if (this.obj_ad['TM'] == 1) {
                    this.obj_ad['PM'] = 3;
                    this.obj_ad['DSRT'] = "::[MTA][DST]::";   //this.getLanguage["MTA"]["DST"];
                    this.obj_ad['DSRM'] = "::[MTA][DSM]::";   //this.getLanguage["MTA"]["DSM"];
                }

                if (this.obj_ad['AGIT'] != null) {
                    var selectedAGI = 0;
                    if (this.getUserInfo.AT == 4) {
                        selectedAGI = this.obj_ad['AGIT'].extra;
                    }
                    else {
                        var agiSelectedValue = this.obj_ad['AGIT'].id;
                        var agentList = agiSelectedValue.split("-");
                        selectedAGI = agentList[agentList.length - 1];
                    }

                    this.obj_ad.AGI = selectedAGI;
                }

                this.obj_ad["RURL"] = this.selectedFile;

                if (ccp) {
                    this.obj_ad["CCP"] = 1;
                    this.obj_ad["CCPR"] = this.getLanguage["PM"]["H2PCCPR"];
                }
                else {
                    this.obj_ad["CCP"] = 0;
                    this.obj_ad["CCPR"] = '';
                }

                if (this.hasTransLoading) return; 
                
                this.$v.obj_ad.$touch();
                if (!this.$v.obj_ad.$error) {
                    this.bool_fullLoading = false;
                    this.$fire({
                        title: this.getLanguage["MTA"]["CA"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        keydownListenerCapture: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            var that = this;
                            this.bool_fullLoading = true;
                            this.bool_fullScreen = true;
                            this.hasTransLoading = true; 
                            this.postDataApiWithAttach(`/api/memtrans/ap`, this.obj_ad,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    that.bool_fullScreen = false;
                                    that.hasTransLoading = false;
                                    if (s && d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 6090) {
                                        that.$fire({
                                            // title: this.getLanguage["MTA"]["CA"],
                                            html: that.utilGetErrorLanguage(d.ERR[0].ERRC),
                                            width: '30em',
                                            showCancelButton: true,
                                            confirmButtonText: 'OK',
                                            cancelButtonText: that.getLanguage["GL"]["CANCEL"],
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((confirmRes) => {
                                            if (confirmRes.value == true) {
                                                that.saveDeposit(1);
                                            }
                                        });
                                    }
                                    else if (s) {
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        that.bool_CV = false;

                                        var tempAGIT = that.obj_ad.AGIT;
                                        var tempAGI = that.obj_ad.AGI;
                                        that.obj_ad =
                                        {
                                            AGIT: tempAGIT,
                                            AGI: tempAGI,
                                            MI: null,
                                            TM: that.getUserInfo.AT == 4 ? 1 : 0,
                                            TID: "",
                                            BAI: null,
                                            BNI: null,
                                            MB: "",
                                            MBA: "",
                                            MBN: "",
                                            PMT: null,
                                            R: "",
                                            RS: 2,
                                            IMA: 1,
                                            TT: 1,
                                            PM: null,
                                            RURL: "",
                                            AC: 2,
                                            TA: "",
                                            CI: 0,
                                            CS: "",
                                            DI: 0,
                                            FDA: null,
                                            FCS: null,
                                            ER: 1,
                                            TCS: null,
                                            TER: 1,
                                        };
                                        //that.$router.push("/D/DDU");
                                    }
                                });
                        }
                        else {
                            this.bool_fullLoading = false;
                            this.bool_fullScreen = false;
                            this.hasTransLoading = false; 
                        }
                    });
                } else {
                    this.bool_fullLoading = false;
                    this.hasTransLoading = false; 
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_ad"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
        }

    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Deposit/ManualDeposit.vue